// extracted by mini-css-extract-plugin
export default {"logo":"ShareLink_logo__BwB+C"};